import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useV2Auth } from '@/context/V2AuthContext';

/**
 * Handles the OAuth callback from Emergent Auth.
 * Extracts session_id from URL fragment, exchanges it for a session, then redirects.
 */
export default function AuthCallbackV2() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { refresh } = useV2Auth();
  const API_V2 = process.env.REACT_APP_BACKEND_URL + '/api/v2';

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    async function exchangeSession() {
      try {
        const hash = window.location.hash;
        const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

        if (!sessionId) {
          navigate('/auth', { replace: true });
          return;
        }

        // Exchange session_id with backend
        await axios.post(
          `${API_V2}/auth/google/session`,
          { session_id: sessionId },
          { withCredentials: true },
        );

        // Clear the hash from URL
        window.history.replaceState(null, '', window.location.pathname);

        // Refresh user context and navigate to inbox
        await refresh();
        navigate('/inbox', { replace: true });
      } catch (err) {
        // Google auth callback failed
        navigate('/auth', { replace: true });
      }
    }

    exchangeSession();
  }, [navigate, refresh, API_V2]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-sm text-[var(--muted)] bg-white/80 backdrop-blur-sm rounded-xl px-6 py-4">
        Google-Anmeldung wird verarbeitet ...
      </div>
    </div>
  );
}
